import { colors } from "../constants/theme";

const { default: styled, css } = require("styled-components");

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 -1em;
  ${({ between }) => {
    if (between) {
      return css`
        justify-content: space-between;
      `;
    }
  }}
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 1em;
  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}
`;

export const Button = styled.button`
  background-color: ${colors.buttonColor};
  height: 40px;
  border: none;
  color: #fff;
  font-size: 1em;
  text-align: center;
  line-height: 40px;
  text-decoration: none;
  cursor: pointer;
  :hover {
    opacity: 0.9;
  }
`;

export const ButtonLink = styled(Button).attrs({
  as: "a",
})``;
